var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlAlcoholGelFilled = function SvgHtlAlcoholGelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.333 14A.335.335 0 0 1 2 13.666v-2a.335.335 0 0 1 .333-.333h1.155l.968-.786A2.452 2.452 0 0 1 6 10h3.334a.667.667 0 0 1 .658.779.693.693 0 0 1-.694.554H7.667a.334.334 0 0 0-.236.569.334.334 0 0 0 .236.098h2.464c.303 0 .597-.102.833-.292l1.925-1.54a.69.69 0 0 1 .887 0 .668.668 0 0 1-.027 1.019l-3.15 2.521c-.236.189-.53.292-.833.292H2.333Zm3.72-5.843a2.482 2.482 0 0 1 0-3.1L8 2l1.948 3.054a2.508 2.508 0 0 1 0 3.1A2.674 2.674 0 0 1 8 9.004a2.672 2.672 0 0 1-1.947-.847Z"
  })));
};
export default SvgHtlAlcoholGelFilled;